import React, { useEffect, useState } from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { Spin, Card, Typography, Flex, Button } from 'antd';
import $api from '../../utils/api'
import { Song } from '../../utils/redux/songsSlice';
import { CloseCircleFilled } from '@ant-design/icons'
const { Title } = Typography;

interface AudioFetcherPlayerProps {
  song?: Song;
  setPlayingSong: (song: Song | undefined) => void;
}

const AudioFetcherPlayer: React.FC<AudioFetcherPlayerProps> = ({ song, setPlayingSong }) => {
  const [audioUrl, setAudioUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (song && song.file) {
      const fetchAudio = async () => {
        try {
          const response = await $api.get(
            `${process.env.REACT_APP_API_BASE_URL}/song/download/${song.file}`, 
            { responseType: 'blob' }
          );
          const url = URL.createObjectURL(response.data);
          setAudioUrl(url);
        } catch (error) {
          console.error('Error loading audio:', error);
        } finally {
          setLoading(false);
        }
      };

      fetchAudio();
    } else {
      setAudioUrl(null);
      setLoading(false);
    }
  }, [song]);

  return (
    song && audioUrl ? (
      <Card
        title={
          <Flex align="center" gap={10}>
            <div style={{ flexGrow: 1, flexShrink: 1, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
              {song.artist} - {song.title}
            </div>
            <Button type='text' onClick={() => setPlayingSong(undefined)}>
              <CloseCircleFilled />
            </Button>
          </Flex>
        }
        variant="borderless"
      >
        {loading ? (
          <Spin size="large" />
        ) : audioUrl ? (
          <AudioPlayer
            autoPlay={true}
            src={audioUrl}
            showJumpControls={false}
            showDownloadProgress={false}
            showFilledVolume={false}
            showSkipControls={false}
          />
        ) : (
          <p>Unable to load audio.</p>
        )}
      </Card>
    ) 
    : <></>
  );
};

export default AudioFetcherPlayer;